export const getFormattedPreviewUrl = ({
  basePreviewUrl,
  previewUrl
}) => {
  const url = previewUrl || basePreviewUrl;
  return url.startsWith('http') ? url.replace(/^http:\/\//i, 'https://') : `https://${url}`;
};